export default "__VITE_ASSET__m3WZ_Ktc__"